<template>
  <div>
    <multiselect
      v-model="valoresCampo"
      :options="campo.opciones"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      :max="campo.max_select_option"
      :placeholder="`Seleccione solo ${campo.max_select_option}`"
      :deselectLabel="'presione enter para remover'"
      :selectLabel="'presione enter para seleccionar'"
      :selectedLabel="'seleccionado'"
      track-by="val"
      label="val"
      @input="onChange"
      @close="onTouch"
      @select="onSelect"
    >
      <template slot="maxElements">
        <p>Máximo {{ campo.max_select_option }} elementos</p>
      </template>
      <template slot="selection" slot-scope="{ values, search, isOpen }">
        <span
          class="multiselect__single"
          v-if="values.length &amp;&amp; !isOpen"
        >
          {{ values.length }} opciones seleccionadas
        </span>
      </template>
    </multiselect>
    <!-- <label class="typo__label form__label" v-show="isInvalid"
      >Debe seleccionar al menos {{ campo.max_select_option }} opciones</label
    > -->
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  props: {
    campo: Object,
    value: Array
  },
  data() {
    return {
      isDisabled: false,
      isTouched: false,
      valoresCampo: []
    };
  },
  computed: {
    valid() {
      return (
        this.valoresCampo.length >= 2 &&
        this.valoresCampo.length <= this.campo.max_select_option
      );
    }
  },
  mounted() {},
  methods: {
    onChange(value) {
      // console.log(value);
      this.$emit("input", value);
    },
    onSelect(option) {
      console.log(option);
    },
    onTouch() {
      console.log("");
    }
  },
  watch: {
    // valoresCampo: val => {
    //   // this.$emit("input", val);
    // }
  }
};
</script>

<style></style>
